import React from "react";
import { BasketItem } from "../../models/BasketItem";
import BasketItemPanel from "./BasketItemPanel";
import "./style.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";

interface IProps {
  colorClass: string;
  basket: BasketItem[];
  onRemoveToBasket: (index: number) => void;
  isWide?: boolean;
}

const Basket: React.FC<IProps> = ({ colorClass, basket, onRemoveToBasket, isWide = false }: IProps) => {
  const isDesktop = useDesktopSize();
  const handleRemoveBasket = (index: number) => {
    onRemoveToBasket(index);
  };

  return (
    <div className={`basket-wrapper ${!isWide && !isDesktop ? "basket-finalize-mobile" : ""}`}>
      {basket.map((item: BasketItem, index: number) => (
        <BasketItemPanel
          key={index}
          colorClass={colorClass}
          itemBasket={item}
          onRemoveToBasket={() => handleRemoveBasket(index)}
          isWide={isWide}
        />
      ))}
    </div>
  );
};

export default Basket;
